import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IJoinAppWaitlist_Request, IJoinAppWaitlist_Response } from './join-app-waitlist.model';
import { ApiService } from '../api/api.service';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class JoinAppWaitlistService {

  private endpoint = "external";
  private appId = environment.PopTheBallonDatingAppId;

  constructor(private apiService: ApiService) { }

  getAll(pageNumber: number, pageSize: number) {
    const params = new HttpParams()
      .set('pageNumber', pageNumber.toString())
      .set('pageSize', pageSize.toString());
    return this.apiService.getAllPageed<IJoinAppWaitlist_Response>({
      Url: `${this.endpoint}/join-app-waitlist/appId/${this.appId}`,
      Params: params
    });
  }

  getById(id: string) {
    return this.apiService.get<IJoinAppWaitlist_Response>({
      Url: `${this.endpoint}/${id}`,
    });
  }

  create(report: IJoinAppWaitlist_Request) {
    return this.apiService.post<IJoinAppWaitlist_Request, IJoinAppWaitlist_Response>({
      Url: `${this.endpoint}`,
      Body: report
    });
  }

  update(id: string, body: IJoinAppWaitlist_Request) {
    return this.apiService.put<IJoinAppWaitlist_Request, object>({
      Url: `${this.endpoint}/${id}`,
      Body: body
    });
  }

  delete(id: string) {
    return this.apiService.delete<object, object>({
      Url: `${this.endpoint}/${id}`,
      Body: {}
    });
  }
}
